import { Box, Container, Link, Stack } from '@mui/material';
import { FC } from 'react';
import { useComponentHeightMeasuring } from '../../utils/hooks/useComponentHeightMeasuring';

export type ButtonType = { label: string; element: HTMLDivElement };

type AdditionalHeaderProps = {
	buttons: ButtonType[];
};

const AdditionalHeader: FC<AdditionalHeaderProps> = ({ buttons }) => {
	const { headerHeight } = useComponentHeightMeasuring();

	return (
		<Box
			sx={{
				position: 'sticky',
				backgroundColor: 'background.paper',
				borderBottom: 1,
				borderBottomColor: 'divider',
				zIndex: 1000,
				top: headerHeight,
			}}
		>
			<Container>
				<Box py={1}>
					<Stack spacing={4} direction="row">
						{buttons.map(({ element, label }) => (
							<Link
								key={label}
								href={`#${element.id}`}
								onClick={(event) => {
									event.preventDefault();
									element.scrollIntoView({
										behavior: 'smooth',
										block: 'center',
									});
								}}
								sx={{
									textDecoration: 'none',
									color: 'text.secondary',
									fontSize: 14,

									'&:hover': {
										color: 'text.primary',
										textDecoration: 'none',
									},
								}}
							>
								{label}
							</Link>
						))}
					</Stack>
				</Box>
			</Container>
		</Box>
	);
};

export default AdditionalHeader;
